import { getSuccessToast, getErrorToast } from '../constructor/helpers/toasts'

type TEnvelope<T> = { status: number; data: T }

// есть ли метки редиректа из Т-Кассы
function hasTinkoffMarks(u: URL) {
    const p = u.searchParams
    return (
        p.has('Success') ||
        p.has('Fail') ||
        p.has('PaymentId') ||
        p.has('success_redirect') ||
        p.has('fail_redirect')
    )
}

// подчистка query, чтобы не триггерить повторно
function cleanQuery(u: URL) {
    ['Success','Fail','PaymentId','OrderId','Amount','ErrorCode','Message','Details','success_redirect','fail_redirect','sale_id','visit_id']
        .forEach(k => u.searchParams.delete(k))
    window.history.replaceState({}, '', u.toString())
}

/**
 * Инициализация финализации платежа Т-Кассы.
 * Вызывай 1 раз при старте приложения.
 * @param callApi твоя функция api(object, command, data) -> Promise<TEnvelope<T>>
 */
export async function initPaymentsFinalize(
    callApi: <T = any>(object: string, command: string, data?: any) => Promise<TEnvelope<T>>
) {
    try {
        const url = new URL(window.location.href)
        if (!hasTinkoffMarks(url)) return

        const saleId    = Number(url.searchParams.get('sale_id') || 0)
        const visitId   = Number(url.searchParams.get('visit_id') || 0)
        const Success   = url.searchParams.get('Success') || url.searchParams.get('success_redirect') || ''
        const PaymentId = url.searchParams.get('PaymentId') || ''
        const OrderId   = url.searchParams.get('OrderId') || ''

        // защита от повторной обработки (F5)
        const dedupeKey = 'tkassa_finalize_' + (PaymentId || OrderId || (saleId ? `sale_${saleId}` : 'unknown'))
        if (sessionStorage.getItem(dedupeKey) === 'done') {
            cleanQuery(url)
            return
        }

        const resp = await callApi<{ ok: boolean; status: string }>(
            'salesList',
            'finalize',
            { sale_id: saleId || undefined, visit_id: visitId || undefined, Success, PaymentId, OrderId }
        )

        sessionStorage.setItem(dedupeKey, 'done')
        cleanQuery(url)

        const ok = Number(resp?.status) === 200 && !!resp?.data && (resp.data as any).ok === true

        window.dispatchEvent(new CustomEvent('payment-finalized', { detail: resp?.data ?? { ok:false } }))
    } catch {
        window.dispatchEvent(new CustomEvent('payment-finalized', { detail: { ok:false, reason:'Ошибка подтверждения оплаты' } }))
    }
}
